<template>
<div class="popup" v-if="notificationsShow" style="position:fixed">
        <div class="notifiy-content" id="notifications" v-show="contentShow" style="position:fixed">
            <div class="title">
                {{$t('language.rightTopBanner.notification')}}
                <div class="icon white-close dialog-close" id="dialogClose" @click="close()"></div>
            </div>
            <div class="notification-content">
                <div id="notificationContainer" v-html="$t('language.popup.addCloudPopup.notificationTip')">
                </div><br>
                <b>{{$t('language.popup.addCloudPopup.notAbleAccess')}}</b>
                <div>{{$t('language.popup.addCloudPopup.problemNotAccess')}}</div><br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}7.0.0</b>
                    <div>Released on 2024/04/29</div>
                    <b>New :</b>
                    <div>MultCloud now supports 4shared.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}6.3.0</b>
                    <div>Released on 2024/02/29</div>
                    <b>New :</b>
                    <div>MultCloud now supports Icedrive.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}6.2.0</b>
                    <div>Released on 2024/01/30</div>
                    <b>New :</b>
                    <div>Chrome Extensions: MultCloud Save - Save Webpage as PDF.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}5.5.0</b>
                    <div>Released on 2023/09/11</div>
                    <b>New :</b>
                    <div>MultCloud now supports Outlook.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}5.3.0</b>
                    <div>Released on 2023/06/30</div>
                    <b>New :</b>
                    <div>MultCloud now supports iCloud Drive.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}5.2.0</b>
                    <div>Released on 2023/05/31</div>
                    <b>New :</b>
                    <div>MultCloud now supports Gmail.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}5.0.0</b>
                    <div>Released on 2023/03/15</div>
                    <b>New :</b>
                    <div>MultCloud now supports iCloud Photos.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.9.0</b>
                    <div>Released on 2023/02/14</div>
                    <b>New :</b>
                    <div>Bug fixes on cloud backup and restore.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.8.7</b>
                    <div>Released on 2022/07/07</div>
                    <b>New :</b>
                    <div>SharePoint online storage supported.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.8.5</b>
                    <div>Released on 2022/06/08</div>
                    <b>New :</b>
                    <div>Share Transfer.</div>
                    <div>With this feature, you can deliver large files to anyone easily.</div>
                    <b>Quick Guide :</b>
                    <div>1.Right click on the file you'd like to send (in order to select the file, please add the cloud where the file exists to Multcloud first).</div>
                    <div>2.Navigate to "Share" and select "Create a Transfer".</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.8.2</b>
                    <div>Released on 2022/05/30</div>
                    <b>New :</b>
                    <div>Wasabi Cloud Added.</div>
                    <div>Wasabi users can now connect Wasabi to MultCloud.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.8.0</b>
                    <div>Released on 2022/01/20</div>
                    <b>New :</b>
                    <div>Team Transfer.</div>
                    <div>Easily to migrate business clouds from one tenant to another. Google Workspace (and Shared Drive), OneDrive for Business, Dropbox Business, Box for Business supported.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.7.0</b>
                    <div>Released on 2021/11/05</div>
                    <b>New :</b>
                    <div>Cloud-to-cloud backup and restore feature added.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.6.8</b>
                    <div>Released on 2021/09/30</div>
                    <b>New :</b>
                    <div>All clouds are supported for Real-time Sync.</div>
                    <b>Improved :</b>
                    <div>UI improved on sharing page.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.6.7</b>
                    <div>Released on 2021/07/01</div>
                    <b>New :</b>
                    <div>Cloud-to-cloud sync tasks now support real time sync.</div>
                    <b>Improved :</b>
                    <div>Speed improvements for new created transfer and sync tasks.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.6.5</b>
                    <div>1.Released new UI.</div>
                    <div>2.Supported uploading torrent to cloud.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.5.7</b>
                    <div>1.Added NAS.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.5.6</b>
                    <div>1.Fixed the problem that Google Photos could not be accessed.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.5.5</b>
                    <div>1.Improve the function of sharing MultCloud for free traffic.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.5.4</b>
                    <div>1.Add Multi-Source transfer function.</div>
                    <div>2.Add Online File Encryption and Decryption.</div>
                    <div>3.Add Filename Encryption option to File Encryption function.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.5.3</b>
                    <div>1.Optimize Dropbox for Business cloud.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.5.2</b>
                    <div>1.New premium feature: File Uploading Encryption.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.5.1</b>
                    <div>1.Improvements to MultCloud transport server.</div>
                    <div>2.Free and premium plan updated.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.5.0</b>
                    <div>1.Add recycle bin for some clouds.</div>
                    <div>2.Modify some interfaces of our website.</div>
                    <div>3.Optimize some functions.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.4.4</b>
                    <div>1.Add Google Photos and Put.io.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.4.3</b>
                    <div>1.Add One-way Multi-target Sync function.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.4.2</b>
                    <div>1.Add Backblaze.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.4.1</b>
                    <div>1.Add Google Drive for G Suite.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.4.0</b>
                    <div>1.Add Sub-Accounts Management.</div>
                    <div>2.Improve Google cloud drive.</div>
                    <div>3.Fix some cloud drive bugs.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.3.1</b>
                    <div>1.Improve OneDrive for Business authorization function and solve the problem that some users can not add this cloud.</div>
                    <b>Note :</b>
                    <div>Please re-add your OneDrive for Business cloud and transfer tasks for users that have added this cloud, sorry for the inconvenience.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.3.0</b>
                    <div>1.Added support for pCloud drive.</div>
                    <div>2.Fix some cloud drive bugs.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.2.0</b>
                    <div>1.Multilanguage adds German and traditional Chinese.</div>
                    <div>2.Improve Dropbox cloud drive.</div>
                    <div>3.Improve share feature and add upload & new folder actions in share page.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.1.0</b>
                    <div>1.Add points system.</div>
                    <div>2.Add history-error view feature.</div>
                    <div>3.Add manual retry button when transfer fails.</div>
                    <div>4.Improve search, share, transfer progress features.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.0.0</b>
                    <div>1.Add Cloud Synchronization function, include one -way sync,two-way sync and so on.</div>
                    <div>2.Added support for OneDrive for Business, Dropbox for Business and Egnyte cloud drives.</div>
                    <div>3.Improve Share function.</div>
                    <div>4.Improve UI.</div>
                    <div>5.Fix transfer bugs.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.8.0</b>
                    <div>1.Upgrade share function, add folder share, share management, save share, transfer share functions.</div>
                    <div>2.Add "Upload URL" option in upload function.</div>
                    <div>3.Fix some cloud drive bugs.</div>
                    <div>4.Remove Copy cloud drive.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.7.0</b>
                    <div>1.Add mega and Evernote cloud drives.</div>
                    <div>2.Add preview support of text files, such as txt, html, js.</div>
                    <div>3.Optimize the schedule tasks.</div>
                    <div>4.Fix the bug of transfering Google documents between Google Drives to keep file types consistent.</div>
                    <div>5.Amazon S3 support that transfering a singal file greater than 5 Gb.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.6.0</b>
                    <div>1.Add hubiC cloud drive.</div>
                    <div>2.Add"Experience without signing up" function for quick experience.</div>
                    <div>3.Add "Go to official site" function for some cloud drives.</div>
                    <div>4.Fix transmission bugs of OneDrive and Google Drive.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.5.0</b>
                    <div>1.Improve the speed of cross-cloud transmission for VIP users.</div>
                    <div>2.Add MySQL backup and Flickr cloud drive.</div>
                    <div>3.Fix some bugs of schedule transfer.</div>
                    <div>4.Fix the bug that can not list files of FTP and WebDav.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.4.0</b>
                    <div>1.Add MediaFire to MultCloud.</div>
                    <div>2.Add OwnCloud to MultCloud.</div>
                    <div>3.Modify the scheduled file transfer.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.3.0</b>
                    <div>1.Add Alfreco to MultCloud.</div>
                    <div>2.Add aDrive to MultCloud.</div>
                    <div>3.Modify the break exception for transmission across the different clouds.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.2.0</b>
                    <div>1.Added the "replacement" option.</div>
                    <div>2.Upgrade OneDrive API, and remove some limits.</div>
                    <div>3.Modified the bug of amazon cloud drive.</div>
                    <div>4.Optimize transmission environment.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.1.0</b>
                    <div>1.Support Amazon cloud drive.</div>
                    <div>2.Support replacing or skipping some files during file transfer.</div>
                    <div>3.Enhance SFTP service: Support logging in with Private key.</div>
                    <div>4.Optimize transfer function.</div>
                    <div>5.Fixed some cloud drive bugs.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.0.0</b>
                    <div>1.Add new functions as Transfer and Task Manager.</div>
                    <div>2.Support setting of Scheduled Transfer and File Filter.</div>
                    <div>3.Support notifying by emailing automatically after transferring.</div>
                    <div>4.Support re-edit the accounts and view the properties of cloud drives.</div>
                    <div>5.Adjust and optimize some UIs.</div>
                    <div>6.Enhance the stability and speed of transfer by optimizing the network environment.</div>
                    <div>7.Fixed some bugs.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}2.3.1</b>
                    <div>1.Remove the "background" button, and all the transmission tasks will be set to background as default.</div>
                    <div>2.Fixed some bugs.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}2.3.0</b>
                    <div>1.Add the function of background transmission.</div>
                    <div>2.Improve the transmission ability.</div>
                    <div>3.Add the function of showing the sizes of cloud drives.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}2.2.2</b>
                    <div>1.Add the function for displaying a right-click menu for tablets, mobile devices.</div>
                    <div>2.Modify the exceptions about register, find password. Also allows you to skip activation for using MultCloud.</div>
                    <div>3.Modify the exception that it's unable to add the server address which begins with http for WebDav.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}2.2.1</b>
                    <div>1.Modify the exceptions about list,search,copy files of Google Drive.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}2.2.0</b>
                    <div>1.Modify the bulk transmission exceptions for the higher transmission stability.</div>
                    <div>2.Add the function that scanning the details of transmission progress.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}2.1.0</b>
                    <div>1.Modify the problem that file lists display incompletely.</div>
                    <div>2.Modify the exceptions about file upload,download and transmission in FTP.</div>
                    <div>3.Modify the break exception for transmission across the different clouds.</div>
                    <div>4.Modify the UI of adding FTP and WebDav.</div>
                    <div>5.Add some notes for each cloud drive.</div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}2.0.0</b>
                    <div>1.Add FTP to MultCloud.</div>
                    <div>2.Add WebDav to MultCloud.</div>
                    <div>3.Add the menu option:"Copy to".</div>
                    <div>4.Login with Google and Facebook Account.</div>
                    <div>5.Improve user-interface to more easy-to-use.</div>
                    <div>6.Some bug fixes.</div>
                    <div>7.Support Cubby, MyDrive, Web.de, Yandex, CloudMe, HiDrive, Copy and BaiDu.</div>
                </div>
                <br>
            </div>
            <div class="notificate-footer">
                <div style="float:left;position:relative;top:8Px;line-height:30Px;"  @click.stop="checkBox()">
                <span id="checkIcon" class="icon-util  notification-check-position" :class="check?'check-small':'nocheck-small'" @click.stop="checkBox()"></span>
                <span class="notice-text">{{$t('language.popup.addCloudPopup.noPrompt')}}</span>
                </div>
                <button style="float:right;margin-right:10Px;width:110Px;position:relative;top:8Px;"   @click="sure()">OK</button>
            </div>
        </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data: function () {
        return {
            notificationsShow: false,
            contentShow: false,
            check: false,
            versions: [],
            timejson:null
        }
    },
    created() {

    },
    methods: {
        sure(){
         let user = commonUtils.getUser();
         this.$cookies.set("check"+user.id,this.check, "1y");   
         this.close();
        },
        getTxtInfo(value){
   if (!value) return '';
      let str1=value.substr(value.indexOf(":")+1,value.length);
     // let strFirst=str1.substr(0,str1.indexOf(":"));
      let str=str1.substr(str1.indexOf(":")+1,str1.length);
    //   console.log(strFirst);
    //   console.log(str1);
    //   let strInfo={
    //    first:strFirst,
    //    info:str
    //   }
      if(str.indexOf(':')!=-1){
         var args = str.split(':');
        // console.log(args);
         str =args[0]+'<br>'+args[1];  
      }
     // console.log(str);
      return str;
        },
        close() {
        let that = this;
        //目标div的offset
        var notice = $('#notifyIcon').offset();
     $('#notifications').animate({
    		left:notice.left+22,
    		top:notice.top+12,
    		marginLeft:0,
    		marginTop:0,
    		height:0,
			width:0
		  },1300);
            this.$parent.newNotifyShow=false;
            let t = setTimeout(function () {
                that.notificationsShow = false;
                that.$parent.letPassWordShow = false;
                that.$parent.showPassWord();
                that.$parent.letTimeSalePassWordShow = false;
                commonUtils.updateViewTime();
                clearTimeout(t);
            }, 1200);
        },
   checkBox(){
            this.check=!this.check;
    },
    },
     filters: {
    getInfo (value) {
      if (!value) return '';
      let str1=value.substr(value.indexOf(":")+1,value.length);
     // let strFirst=str1.substr(0,str1.indexOf(":"));
      let str=str1.substr(str1.indexOf(":")+1,str1.length);
    //   console.log(strFirst);
    //   console.log(str1);
    //   let strInfo={
    //    first:strFirst,
    //    info:str
    //   }
      if(str.indexOf(':')!=-1){
         var args = str.split(':');
         //console.log(args);
         str =args[0]+'\t'+args[1];  
      }
      //console.log(str);
      return str;
    },

  }
}
</script>

<style>
#notifications {
    width: 500px;
    /*no*/
    height: 500px;
    /*no*/
}

.notification-content {
    width: 100%;
    height: 380px;
    /*no*/
    box-sizing: border-box;
    padding: 0px 10px 0 20px;
    /*no*/
    overflow: auto;
    font-size: 13px;
    /*no*/
    color: #595959;
    line-height: 20px;
    /*no*/
    margin-top: 20Px;
}

.notification-content::-webkit-scrollbar {
    width: 8px;
    /*no*/
    height: 0px;
    /*no*/
    background-color: #fff;
}

.notification-content::-webkit-scrollbar-thumb {
    height: 1px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}

.notificate-footer {
    width: 100%;
    height: 20px;
    /*no*/
    float: left;
}

.notice-text {
    font-size: 14px;
    /*no*/
    color: #858585;
    position: relative;
    left: 10Px;
}

.notification-check-position {
    position: relative;
    left: 10px;
    /*no*/
    top: 3px;
    /*no*/
    cursor: pointer;
}
/* 
.bounce-enter-active {
    transform-origin: 76% 10%;
}

.bounce-leave-active {
    transform-origin: 122% -23%;
    animation: bounce-in 1.2s reverse;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }
  
    50% {
        transform: scale(0.6, 0.8);
    }
    

    80% {
        transform: scale(0.7, 1);
    }


    100% {
        transform: scale(0.8, 1);
    }

    font {
        transform: scale(1, 1);
    }
} */

.notifiy-content {
    box-sizing: border-box;
    border: 1px solid #8a96e3;
    /*no*/
    background-color: #fff;
    position: absolute;
    margin: auto;
    z-index: 700;
    bottom: 0;
    /*no*/
    right: 0;
    left: 0;
    top: 0;
}

#notifications .font {
    transform: scale(1);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/personal_center_popups/notifications_popup.vue